import React from 'react';
import { TeamRegistrationService } from '../TeamRegistrationService';
import TaxIcon from '../../../assets/images/tax.svg';

interface TaxSummaryProps {
    net: number;
    vat: number;
    gross: number;
    symbol: string;
    shouldShow: boolean;
}

const TaxSummary: React.FC<TaxSummaryProps> = ({ net, vat, gross, shouldShow, symbol }) => {
    if (!shouldShow) return null;

    const vatPercent = Math.round((vat / Math.max(net, 1)) * 100);

    return (
        <div className="text-md cursor-default rounded-r-lg py-2 px-4 flex  text-black mt-5 group items-center relative overflow-hidden border-l-2 border-l-[#606277] bg-gradient-to-r from-[#FB5151]/5 to-[#606277]/1 font-semibold border border-gray-200">
            <div className='text-[9px] absolute top-1.5 left-12 text-gray-500 px-2'>{symbol}</div>
            <img src={TaxIcon} className='w-10 h-10 top-0 right-0' />
            <img src={TaxIcon} className='w-100 h-100 group-hover:opacity-20 opacity-10 transition-all duration-300 absolute right-10 -top-8 right-0' />
            <div className="mt-2">Nettobetrag <span className="text-[#FB5151]">{TeamRegistrationService.formatCurrencyDE(net)}</span> zzgl. <span className="text-[#FB5151]">{vatPercent}%</span> MwSt. <span className="text-[#FB5151]">({TeamRegistrationService.formatCurrencyDE(vat)})</span> = <span className="text-[#FB5151]">{TeamRegistrationService.formatCurrencyDE(gross)}</span></div>
        </div>
    );
};

export default TaxSummary;


